module.exports = __webpack_public_path__ + "static/images/32f08eed601847c7fbf1ee3151204bd3.webp";